import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.url.startsWith('/api/') && !request.url.startsWith('/legacy/')) {
    return next(request);
  }

  return next(request.clone({ withCredentials: true }));
};
